import { EndingSoonNotification } from 'components/notifications/EndingSoonNotification';
import { NewLiveReferralNotification } from 'components/notifications/NewLiveReferralNotification';
import { OutbidNotification } from 'components/notifications/OutbidNotification';
import { PendingIntakeNotification } from 'components/notifications/PendingIntakeNotification';

export const NotificationTypes = {
    END_SOON: 'END_SOON',
    NEW_REFER: 'NEW_REFER',
    OUTBID: 'OUTBID',
    PENDINTAKE: 'PENDINTAKE',
    // Summary emails
    WORKSUM: 'WORKSUM',
    LIVEREFSUM: 'LIVEREFSUM',
    WONREFSUM: 'WONREFSUM',
} as const;

// notification component map
export const NotificationComponentMap = {
    [NotificationTypes.END_SOON]: EndingSoonNotification,
    [NotificationTypes.NEW_REFER]: NewLiveReferralNotification,
    [NotificationTypes.OUTBID]: OutbidNotification,
    [NotificationTypes.PENDINTAKE]: PendingIntakeNotification,
} as const;
